module.exports = __webpack_public_path__ + "img/dashboard-mob.8df05d50.svg";